<template>
  <v-hover v-slot="{ hover }">
    <v-card
      :elevation="hover ? 12 : 0"
      :disabled="$store.getters.isLoading"
      width="100%"
    >
      <v-expansion-panel
        :v-ripple="!$store.getters.isLoading"
        :class="{ active: active }"
        class="list-item"
      >
        <v-expansion-panel-header
          v-if="isReady && !$store.getters.isLoading"
          class="list-item-height"
          ripple
        >
          <div v-if="icon" class="pr-4">
            <slot name="icon" />
          </div>

          <v-container fluid fill-height pa-0 ma-0>
            <v-row no-gutters>
              <slot name="body" />
            </v-row>
          </v-container>

          <template v-slot:actions>
            <slot v-if="actions" name="actions" />
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-header v-else class="list-item-height" ripple>
          <v-skeleton-loader type="list-item-avatar-two-line" />
        </v-expansion-panel-header>
        <v-expansion-panel-content class="expantion">
          <slot name="expantion" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-card>
  </v-hover>
</template>

<script>
export default {
  name: "CardItemsExpandComponents",
  props: {
    active: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: Boolean,
      default: true,
    },
    isReady: {
      type: Boolean,
      default: true,
    },
    actions: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.list-item {
  background-color: white;
  border: solid;
  border-color: rgba(56, 56, 56, 0.2);
  border-width: 0.5px !important;
  border-radius: 5px;
}
.list-item.active {
  border-color: var(--v-primary-base) !important;
}
.list-item-height {
  height: 72px;
}
</style>
